import { useEffect, useMemo } from "react";

import classNames from "classnames";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import useWindowSize from "../../../hooks/useWindowSize";
import useGetSettings from "../../../hooks/useGetSettings";

import { setSettings } from "../../../redux/reducers/settingsReducer";

import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Landing from "../../../pages/Landing.jsx";
import { errorToast } from "../../../components/toast";
import GoogleComponent from "../../../components/google-component";
import DialogContainer from "../../../components/dialog-container";
import HeaderComponent from "../../../components/header-component";
import FooterComponent from "../../../components/footer-component";

import { logDebug, logError } from "../../../utils/logger";
import { isEmpty, isEmptyObject } from "../../../utils/validators";

function UploadLayout() {
  const { t } = useTranslation();

  const windowSize = useWindowSize();

  const dispatch = useDispatch();
  const { ui } = useSelector((state) => state);

  const {
    data: dataGetSettings,
    error: errorGetSettings,
    loading: loadingGetSettings,
    getSettings,
    clear: clearGetSettings,
  } = useGetSettings();

  const isUpperSm = useMemo(() => {
    return windowSize.width >= 576;
  }, [windowSize.width]);

  const isBlur = useMemo(() => {
    return !isEmptyObject(ui) ? ui.is_blur : false;
  }, [ui]);

  const showFooter = useMemo(() => {
    return !isEmptyObject(ui) ? ui.show_footer_menu : false;
  }, [ui]);

  useEffect(() => {
    getSettings();
  }, [getSettings]);

  useEffect(() => {
    if (!loadingGetSettings) {
      if (!isEmpty(errorGetSettings)) {
        logError("UploadLayout", "getSettings", {
          error: errorGetSettings,
          msg: t(`errors.${errorGetSettings}`, t("errors.default")),
        });
        errorToast(
          "UploadLayout - getSettings",
          errorGetSettings,
          t(`errors.${errorGetSettings}`, t("errors.default"))
        );
        clearGetSettings();
      } else if (!isEmptyObject(dataGetSettings)) {
        logDebug("UploadLayout", "getSettings", { data: dataGetSettings });
        dispatch(setSettings(dataGetSettings));
      }
    }
  }, [
    dataGetSettings,
    errorGetSettings,
    loadingGetSettings,
    t,
    dispatch,
    clearGetSettings,
  ]);

  return (
    <>
      <GoogleComponent />
      <ToastContainer />
      <DialogContainer />
      <div className={classNames("grid", { blur: isBlur })}>
        <div className="page1">
          <div className="page1__header">
            <HeaderComponent />
          </div>
          <div className="page1__body">
            {/* Outlet SIEMPRE en el mismo lugar del árbol (igual que el dominio):
                la ruta hija decide el contenido (/r/:id → FileRequestsPublicPage).
                Antes se montaba el Downloader fijo en desktop, lo que ignoraba el
                Outlet y rompía las rutas de file requests. */}
            <Outlet />
          </div>
          <div className="page1__footer">
            {showFooter && <FooterComponent />}
          </div>
        </div>
        {isUpperSm && (
          <div className="page2">
            <Landing />
          </div>
        )}
      </div>
    </>
  );
}

export default UploadLayout;
